import React, { useEffect, useRef } from 'react';
import twemoji from 'twemoji';
import './EmojiText.css';

interface EmojiTextProps {
    children: string;
    className?: string;
    tag?: keyof JSX.IntrinsicElements;
    [key: string]: any;
}

const EmojiText: React.FC<EmojiTextProps> = ({ 
    children, 
    className, 
    tag: Tag = 'span',
    ...props 
}) => {
    const ref = useRef<HTMLElement>(null);

    useEffect(() => {
        if (ref.current) {
            twemoji.parse(ref.current, {
                folder: 'svg',
                ext: '.svg',
                base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@latest/assets/',
                className: 'emoji'
            });
        }
    }, [children]);

    const combinedClassName = className ? `emoji-text ${className}` : 'emoji-text';

    return React.createElement(
        Tag,
        { 
            ref: ref as any,
            className: combinedClassName,
            ...props 
        },
        children
    );
};

export default EmojiText;

